import React, { useEffect } from 'react'
import classes from './OutputPinCircle.module.css'
import outputRed from '../../../assets/stateIcons/output_red.png'
import outputGreen from '../../../assets/stateIcons/output_green.png'
import outputGrey from '../../../assets/stateIcons/pin_disabled.png'
import lockIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/lock_yellow.png'
import pulse from '../../../assets/stateIcons/pulse.png'
import yellowWarn from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import amberWarn from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/amber_warn.png'
import redWarn from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'

import App from '../../../App'
import { red } from '@mui/material/colors'

const OutputPinCircle = ({ OutputPins }) => {

    const getDeviceStatus = (missedPolls) => {

        const POLL_INTERVAL_MINUTES = 10;
        const offlineMs = missedPolls * POLL_INTERVAL_MINUTES * 60 * 1000;
        const offlineSinceDate = new Date(Date.now() - offlineMs).toLocaleDateString()

        if (missedPolls == 1) return "Connectivity issue detected";
        if (missedPolls == 2) return "Frequent connection issues";
        if (missedPolls >= 3) return `Device offline or unresponsive since ${offlineSinceDate}`;
        return "";
    }

    
    return (
        OutputPins.map((OutputPin, index) => {
            let OutputPinImage;

            if (OutputPin.hasLock){
                OutputPinImage = `url(${lockIcon})`;
            } else if (OutputPin.type == "PULSE" || OutputPin.type == "VIRTUAL_PULSE") {
                OutputPinImage = `url(${pulse})`
            } else {
                if (OutputPin.missedPolls > 0) {
                    if (OutputPin.missedPolls == 1) {
                        OutputPinImage = `url(${yellowWarn})`
                    } else if (OutputPin.missedPolls == 2) {
                        OutputPinImage = `url(${amberWarn})`
                    } else if (OutputPin.missedPolls >= 3) {
                        OutputPinImage = `url(${redWarn})`
                    }
                } else if (OutputPin.pinState === 0) {
                    OutputPinImage = `url(${outputGreen})`;
                } else if (OutputPin.pinState === 1) {
                    OutputPinImage = `url(${outputRed})`;
                } else if (OutputPin.pinState === 2) {
                    OutputPinImage = `url(${outputGrey})`;
                }
            }

            return (
                <li key={index}>
                    <div
                        className={classes.output}
                        style={{
                            backgroundImage: OutputPin.active ? OutputPinImage : `url(${outputGrey})`,
                            opacity: OutputPin.active ? 1.0 : 0.0,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundColor: !OutputPin.active ? "lightgrey" : "transparent" 
                        }}

                        title={getDeviceStatus(OutputPin.missedPolls)}
                    />
                </li>
            )
        })
    );
}

export default OutputPinCircle;